"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
var _default = exports.default = {
  getTaskScheduleLogList: function getTaskScheduleLogList(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: "/protected/taskScheduleLog/list",
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getTaskScheduleLogJobList: function getTaskScheduleLogJobList(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: "/protected/taskScheduleLog/jobList",
      method: 'post',
      data: data
    });
  },
  executeTask: function executeTask(data) {
    return (0, _request.default)({
      module: 'TASK',
      url: "/protected/schedule/execute_imm/".concat(data),
      method: 'post',
      data: data
    });
  }
};